import React, { useRef } from 'react';
import AboutHeroSection from '../components/landingPage/AboutUsPage/AboutHeroSection';
import AboutCustomCarousel from '../components/landingPage/AboutUsPage/AboutCustomCarousel';
import AboutWhyExistSection from '../components/landingPage/AboutUsPage/AboutWhyExistSection';
import AboutOurVisionSection from '../components/landingPage/AboutUsPage/AboutOurVisionSection';
import AboutTeamSlider from '../components/landingPage/AboutUsPage/AboutTeamSlider';
import AboutAdvisorySlider from '../components/landingPage/AboutUsPage/AboutAdvisorySlider';
import AboutQuotesSection from '../components/landingPage/AboutUsPage/AboutQuotesSection';
import AboutCtaSection from '../components/landingPage/AboutUsPage/AboutCtaSection';
import { useReveal, useCountUp } from '../components/landingPage/common/landingHooks';

const AboutUs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <AboutHeroSection />
            <AboutCustomCarousel />
            <AboutWhyExistSection />
            <AboutOurVisionSection />
            <AboutTeamSlider />
            <AboutAdvisorySlider />
            {/* <AboutQuotesSection /> */}
            <AboutCtaSection />
        </div>
    );
};

export default AboutUs;
